var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTelefone01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_853",
    d: "M34.5,26.2l-4.9-4.9c-1.2-1.3-3.3-1.3-4.6-0.1c-0.4,0.4-0.6,0.8-0.8,1.3c-0.6,1.6-2.2,2.4-3.8,2.1 c-4.2-1.5-7.5-4.8-9.1-9.1c-0.4-1.6,0.5-3.3,2.1-3.8c1.7-0.6,2.6-2.4,2-4.1c-0.2-0.5-0.4-0.9-0.8-1.3L9.8,1.4 c-1.3-1.2-3.4-1.2-4.7,0L1.8,4.8c-3.3,3.5,0.3,12.7,8.5,20.9s17.4,12,20.9,8.5l3.3-3.3C35.7,29.5,35.7,27.5,34.5,26.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTelefone01);
export default __webpack_public_path__ + "static/media/ico-telefone-01.419b17f0b0fca85fac581394e2f1e34e.svg";
export { ForwardRef as ReactComponent };